import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

export default function AdminPages() {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ title: '', url: '' });

  useEffect(() => { load(); }, []);

  const load = async () => {
    try { const r = await api.get('/pages'); setPages(r.data); } catch (e) { console.error(e); }
  };

  const openModal = (page) => {
    if (page) { setEditing(page); setForm({ title: page.title, url: page.url }); }
    else { setEditing(null); setForm({ title: '', url: '' }); }
    setShowModal(true);
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.title || !form.url) { alert('Completa todos los campos'); return; }
    setLoading(true);
    try {
      if (editing) await api.put(`/pages/${editing.id}`, form);
      else await api.post('/pages', form);
      setShowModal(false); load();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
    finally { setLoading(false); }
  };

  const del = (page) => {
    if (!confirm(`¿Eliminar "${page.title}"?`)) return;
    api.delete(`/pages/${page.id}`).then(load).catch(() => alert('Error'));
  };

  return (
    <>
      <div className="header" style={{ background: '#000' }}>
        <button className="icon-btn" onClick={() => navigate('/admin')}>←</button>
        <h1 className="header-title" style={{ flex: 1 }}>Páginas</h1>
        <button className="add-btn" onClick={() => openModal(null)}>+</button>
      </div>
      <div className="content-scroll" style={{ background: '#000' }}>
        {pages.length === 0 ? (
          <div className="empty-state"><span className="empty-icon">🔗</span><p className="empty-text" style={{ color: '#999' }}>No hay páginas agregadas</p></div>
        ) : pages.map(p => (
          <div key={p.id} className="card-row" style={{ background: '#1a1a1a', border: '1px solid #333' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, cursor: 'pointer' }}
              onClick={() => window.open(p.url, '_blank')}>
              <span style={{ fontSize: '24px', color: '#18cb96' }}>🔗</span>
              <div>
                <div className="card-row-title" style={{ color: '#fff' }}>{p.title}</div>
                <div className="card-row-detail" style={{ wordBreak: 'break-all' }}>{p.url}</div>
              </div>
            </div>
            <div className="card-row-actions">
              <button className="icon-btn-sm" onClick={() => openModal(p)}>✏️</button>
              <button className="icon-btn-sm danger" onClick={() => del(p)}>🗑️</button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content modal-center" onClick={e => e.stopPropagation()} style={{ background: '#1a1a1a', border: '1px solid #333' }}>
            <h3 className="modal-title" style={{ color: '#fff' }}>{editing ? 'Editar Página' : 'Nueva Página'}</h3>
            <form onSubmit={save}>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>Título *</label><input className="input" value={form.title} onChange={e => setForm({...form, title: e.target.value})} required /></div>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>URL *</label><input className="input" type="url" value={form.url} onChange={e => setForm({...form, url: e.target.value})} required /></div>
              <div className="modal-buttons">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={loading}>{loading ? 'Guardando...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
